const request = {
    invalid_input: '입력된 값이 유효하지 않아요. {{details}}',
    general: '요청 중에 오류가 발생했어요.',
    range_not_satisfiable: '범위가 충족되지 않습니다.',
};
export default Object.freeze(request);
